import classNames from 'classnames';
import { FC } from 'react';

import IconTooltip, { IconTooltipProps } from '../../ui/IconTooltip/IconTooltip';

import './FormSection.scss';

interface IProps {
  subheader?: string;
  info?: string;
  className?: string;
  tooltip?: IconTooltipProps;
}

const FormSection: FC<IProps> = ({ subheader, info, className, tooltip, children }) => {
  return (
    <fieldset className={classNames('FormSection', 'mb-5', className)}>
      {!!subheader && (
        <legend className="FormSection-subheader text-left font-weight-bold mb-3">
          {subheader}

          {!!tooltip && <IconTooltip {...tooltip} />}
        </legend>
      )}
      {!!info && <div className="FormSection-info text-left mb-3">{info}</div>}
      {children}
    </fieldset>
  );
};

export default FormSection;
